import $ from 'jquery';
import axios from 'axios';
import InstallationAndVersionInfoMixins from './InstallationAndVersionInfoMixins';
import DateTimeMixin from './DateTimeMixin';
import NumbersMixin from './NumbersMixin';
import { Tooltip } from "@syncfusion/ej2-popups"; 

export default {
    mixins: [InstallationAndVersionInfoMixins, DateTimeMixin, NumbersMixin],
    props: {
        installationAndVersionPrefix: {
            type: String,
            default: null
        }
    },
    methods: {
        getInstallationAndVersionSpecificGridId: function (gridId) {
            return this.addTopsInstallationAndVersionPrefix(gridId);
        },
        isEventTargetWithinElement: function (event, desiredElement) {
            var currentElement = event.target;
            if (currentElement == null) {
                return false;
            }
            while ((currentElement != desiredElement) && currentElement.parentNode) {
                currentElement = currentElement.parentNode;
            }
            return (currentElement == desiredElement);
        },
        defaultEJ2DataGridToolbarItems: function (options) {
            if (!options) {
                options = {
                    grouping: true,
                    export: true,
                    columnchooser: true
                };
            }
            var toolbarItems = [];
            if (options.grouping) {
                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "Expand All", tooltipText: "Expand All", prefixIcon: "fas fa-angle-double-down", id: "expandall" },
                            { text: "Collapse All", tooltipText: "Collapse All", prefixIcon: "fas fa-angle-double-up", id: "collapseall" }
                        ]
                    );
            }
            if (options.export) {
                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "Excel Export", tooltipText: "Excel Export", prefixIcon: "fas fa-file-excel", id: "excelexport" }
                        ]
                    );
            }
            toolbarItems =
                toolbarItems.concat(
                    [
                        "Search"
                    ]
                );
            if (options.columnchooser) {
                toolbarItems =
                    toolbarItems.concat(
                        [
                            "ColumnChooser"
                        ]
                    );
            }
            toolbarItems =
                toolbarItems.concat(
                    [
                        { text: "Reset", tooltipText: "Reset to default state", prefixIcon: "fas fa-eraser", id: "reset", align: "Right" },
                        { text: "Reload", tooltipText: "Reload data", prefixIcon: "fas fa-sync", id: "reload", align: "Right" }
                    ]
                );
            return toolbarItems;
        },
        defaultEJ2DataGridToolbarClickHandler: function(args, grid) {
            if (typeof (grid) === 'undefined') grid = null;
            if (grid == null) grid = this;
            if (args.item.id === 'expandall') {
                grid.groupModule.expandAll();
            } else if (args.item.id === "collapseall") {
                grid.groupModule.collapseAll();
            } else if (args.item.id === 'excelexport') {
                grid.excelExport();
            } else if (args.item.id === 'reload') {
                grid.refresh();
            } else if (args.item.id === 'reset') {
                this.deleteGridSettings(grid).then(() => { window.location.reload() });
            }
        },
        defaultEJ2DataGridCreatedHandler: function(grid) {
            if (typeof (grid) === 'undefined') grid = null;
            if (grid == null) grid = this;
            //  checks whether the cancel icon is already present or not 
            if (grid.element.getElementsByClassName('e-search').length > 0) {
                if (!grid.element.getElementsByClassName('e-search')[0].classList.contains('clear')) {
                    var span = document.createElement('span');
                    span.setAttribute('id', grid.element.id + '_searchcancelbutton');
                    span.setAttribute('class', 'e-input-group-icon e-clear-icon e-icons');
                    span.setAttribute('title', 'Clear Search');
                    span.setAttribute('aria-label', 'clear search');
                    span.addEventListener('click', function () {
                        grid.element.getElementsByClassName('e-search')[0].getElementsByTagName('input')[0].value = "";
                        grid.search("");
                    });
                    grid.element.getElementsByClassName('e-search')[0].appendChild(span);
                    grid.element.getElementsByClassName('e-search')[0].classList.add('clear');
                }
            }
        },
        defaultEJ2DataGridQueryCellInfo: function (args, columnFormats) {
            var columnFormat = columnFormats[args.column.field];
            if (columnFormat) {
                var dataProperty = args.column.field;
                if (columnFormat.dataProperty) {
                    dataProperty = columnFormat.dataProperty;
                }
                var value = args.data;
                dataProperty.split('.').forEach(property => {
                    if (value) {
                        value = value[property];
                    }
                });
                var valueAndStyle = null;
                if (columnFormat.type == 'datetime') {
                    var mode = 'includetime';
                    var inputIsUTC = true;
                    var outputAsUTC = false;
                    if (columnFormat.options) {
                        if (columnFormat.options.mode) mode = columnFormat.options.mode;
                        if (columnFormat.options.inputIsUTC || (columnFormat.options.inputIsUTC === true)) inputIsUTC = columnFormat.options.inputIsUTC;
                        if (columnFormat.options.outputAsUTC || (columnFormat.options.outputAsUTC === true)) outputAsUTC = columnFormat.options.outputAsUTC;
                        if (columnFormat.options.tzMode) {
                            if (columnFormat.options.tzMode == "utc") {
                                inputIsUTC = true;
                                outputAsUTC = false;
                            } else if (columnFormat.options.tzMode == "notz") {
                                inputIsUTC = true;
                                outputAsUTC = true;
                            }
                        }
                    }
                    if (args.name == 'queryCellInfo') {
                        //format of the value on screen
                        args.cell.textContent = this.dateTimeDisplayString(value, mode, inputIsUTC, outputAsUTC);
                    } else {
                        //format for excel export
                        valueAndStyle = this.dateTimeExcelValueAndStyle(value, mode, inputIsUTC, outputAsUTC);
                        if (valueAndStyle) {
                            args.value = valueAndStyle.value;
                            args.style = valueAndStyle.style;
                        }
                    }
                } else if (columnFormat.type == 'currency') {
                    var currencyCode = null;
                    var currencyCodeProperty = null;
                    if (columnFormat.options) {
                        if (columnFormat.options.currencyCode) currencyCode = columnFormat.options.currencyCode;
                        if (columnFormat.options.currencyCodeProperty) currencyCodeProperty = columnFormat.options.currencyCodeProperty;
                    }
                    if (args.name == 'queryCellInfo') {
                        //format of the value on screen
                        if (currencyCodeProperty) {
                            var ccValue = args.data;
                            currencyCodeProperty.split('.').forEach(property => {
                                if (ccValue) {
                                    ccValue = ccValue[property];
                                }
                            });
                            if (ccValue) currencyCode = ccValue;
                        }
                        args.cell.textContent = this.formatAsCurrency(value, currencyCode);
                    } else {
                        //format for excel export
                        args.value = value;
                        args.style = '0,00';
                    }
                } else if (columnFormat.type == 'percentage') {
                    var numberIsPercentage = false;
                    if (columnFormat.options) {
                        if (columnFormat.options.numberIsPercentage || (columnFormat.options.numberIsPercentage === true)) numberIsPercentage = columnFormat.options.numberIsPercentage;
                    }
                    if (args.name == 'queryCellInfo') {
                        //format of the value on screen
                        args.cell.textContent = this.formatAsPercentage(value, numberIsPercentage);
                    } else {
                        //format for excel export
                        if (numberIsPercentage) {
                            value = value / 100.0;
                        }
                        args.value = value;
                        args.style = '0,00%';
                    }
                }
            }
        },
        dateTimeDisplayString: function (dateTime, mode, inputIsUtc, outputAsUtc) {
            if (!dateTime) return null;
            var dateTimeUTCString = this.formatDateTime(dateTime, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, true);
            if ((mode == 'excludetime') ||
                (((mode == 'checktime') || (mode == 'checktimeincludeseconds')) && (dateTimeUTCString.indexOf('00:00:01') > 0))) { //if the required date/time is 1 second past midnight UTC then that actually means there is no specific time, just the date
                return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY', inputIsUtc, outputAsUtc);
            }
            if (mode == 'onlytimewithseconds') {
                return this.formatDateTime(dateTimeUTCString, 'hh:mm:ssA', inputIsUtc, outputAsUtc);
            }
            if (mode == 'onlytime') {
                return this.formatDateTime(dateTimeUTCString, 'hh:mmA', inputIsUtc, outputAsUtc);
            }
            if ((mode == 'includetimewithseconds') || (mode == 'checktimeincludeseconds')) {
                return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY hh:mm:ssA', inputIsUtc, outputAsUtc);
            }
            return this.formatDateTime(dateTimeUTCString, 'DD/MM/YYYY hh:mmA', inputIsUtc, outputAsUtc);
        },
        dateTimeExcelValueAndStyle: function (dateTime, mode, inputIsUtc, outputAsUtc) {
            if (!dateTime) return null;
            var dateTimeUTCString = this.formatDateTime(dateTime, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, true);
            if ((mode == 'excludetime') ||
                (((mode == 'checktime') || (mode == 'checktimeincludeseconds')) && (dateTimeUTCString.indexOf('00:00:01') > 0))) { //if the required date/time is 1 second past midnight UTC then that actually means there is no specific time, just the date
                return {
                    value: this.parseDateTime(this.formatDateTime(dateTimeUTCString, 'YYYY-MM-DD', inputIsUtc, outputAsUtc), null, false, false),
                    style: {
                        numberFormat: 'dd/mm/yyyy'
                    }
                };
            }
            if (mode == 'onlytimewithseconds') {
                return {
                    value: this.parseDateTime(this.formatDateTime(dateTimeUTCString, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, outputAsUtc), null, false, false),
                    style: {
                        numberFormat: 'hh:mm:ss AM/PM'
                    }
                };
            }
            if (mode == 'onlytime') {
                return {
                    value: this.parseDateTime(this.formatDateTime(dateTimeUTCString, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, outputAsUtc), null, false, false),
                    style: {
                        numberFormat: 'hh:mm AM/PM'
                    }
                };
            }
            if ((mode == 'includetimewithseconds') || (mode == 'checktimeincludeseconds')) {
                return {
                    value: this.parseDateTime(this.formatDateTime(dateTimeUTCString, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, outputAsUtc), null, false, false),
                    style: {
                        numberFormat: 'dd/mm/yyyy hh:mm:ss AM/PM'
                    }
                };
            }
            return {
                value: this.parseDateTime(this.formatDateTime(dateTimeUTCString, 'YYYY-MM-DDTHH:mm:ss', inputIsUtc, outputAsUtc), null, false, false),
                style: {
                    numberFormat: 'dd/mm/yyyy hh:mm AM/PM'
                }
            };
        },

        headerCellInfoEvent: function (args) {
            new Tooltip(
                {
                    content: args.cell.column.headerText
                },
                args.node
            );
        },

        setupGridPersistence: function (grid) {
            var relatedTo = grid.element.id;
            $(window).on("beforeunload." + relatedTo, () => {
                this.saveGridSettings(grid, true);
            });
            return this.loadGridSettings(grid);
        },
        
        saveGridSettings: function (grid, onUnload = false) {
            var relatedTo = grid.element.id;

            var url = this.$urlHelper.getApiUrl('SFComponentSettings', relatedTo);
            var serializedGridSettings = grid.getPersistData();
            try {
                var gridSettings = JSON.parse(serializedGridSettings);
                
                serializedGridSettings = JSON.stringify(gridSettings);
            } catch {
                //
            }
            var data = {
                relatedTo: relatedTo,
                name: 'default',
                isDefault: true,
                serializedSettings: serializedGridSettings
            };
            if (onUnload) {
                const blob = new Blob([JSON.stringify(data)], { type: 'application/json; charset=UTF-8' });
                navigator.sendBeacon(url, blob);
            } else {
                axios.post(url, JSON.stringify(data),
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
            }
        },

        loadGridSettings: function (grid) {
            var relatedTo = grid.element.id;

            var url = this.$urlHelper.getApiUrl('SFComponentSettings', 'default', [relatedTo]);
            return axios
                .get(url)
                .then(response => {
                    if (response.data && response.data.serializedSettings) {
                        var gridSettings = JSON.parse(response.data.serializedSettings);
                        if (gridSettings) {
                            var relevantGridSettings = {};
                            if (gridSettings.pageSettings &&
                                gridSettings.pageSettings.pageSize &&
                                (gridSettings.pageSettings.pageSize <= 50) &&
                                gridSettings.pageSettings.currentPage &&
                                gridSettings.pageSettings.pageCount &&
                                gridSettings.pageSettings.totalRecordsCount) {
                                relevantGridSettings.pageSettings = {
                                    pageSize: gridSettings.pageSettings.pageSize,
                                    currentPage: gridSettings.pageSettings.currentPage,
                                    pageCount: gridSettings.pageSettings.pageCount,
                                    totalRecordsCount: gridSettings.pageSettings.totalRecordsCount
                                }
                            }
                            if (gridSettings.sortSettings &&
                                gridSettings.sortSettings.columns) {
                                relevantGridSettings.sortSettings = {
                                    columns: []
                                };
                                gridSettings.sortSettings.columns.forEach(c => {
                                    relevantGridSettings.sortSettings.columns.push({
                                        field: c.field,
                                        direction: c.direction,
                                        isFromGroup: c.isFromGroup
                                    })
                                })
                            }
                            if (gridSettings.columns) {
                                relevantGridSettings.columns = []
                                gridSettings.columns.forEach(c => {
                                    if ((typeof (c.field) != "undefined") && (c.field != null)) {
                                        let col = {
                                            field: c.field
                                        };
                                        if ((typeof (c.visible) != "undefined") && (c.visible != null)) col.visible = c.visible;
                                        if ((typeof (c.width) != "undefined") && (c.width != null)) col.width = c.width;
                                        relevantGridSettings.columns.push(col);
                                    }
                                    
                                });
                            }
                            if (gridSettings.searchSettings &&
                                gridSettings.searchSettings.key) {
                                relevantGridSettings.searchSettings = {
                                    key: gridSettings.searchSettings.key
                                };
                            }
                            var originalDeepMerge = null;
                            if (Object.hasOwn(grid, "deepMerge")) {
                                originalDeepMerge = [...grid.deepMerge];
                                grid.deepMerge.push("columns");
                            } else {
                                grid.deepMerge = ["columns"]; //this ensures that the column props don't override but get merged in with the original ones
                            }
                            grid.setProperties(relevantGridSettings);
                            if (originalDeepMerge) {
                                grid.deepMerge = originalDeepMerge;
                            } else {
                                delete grid.deepMerge;
                            }
                        }
                    }
                });
        },

        deleteGridSettings: function (grid) {
            var relatedTo = grid.element.id;
            $(window).off("beforeunload." + relatedTo);
            var url = this.$urlHelper.getApiUrl('SFComponentSettings', 'removedefaultsetting', [relatedTo]);
            return axios.delete(url)
        }

    }
}